import React from 'react';
import './Button.scss';

type ImagePreviewProps = {
  existingFileName?: string | null;
  existingBlobName?: string | null;
};

const ImagePreview: React.FC<ImagePreviewProps> = ({
  existingFileName,
  existingBlobName
}) => {
  if (!existingBlobName) {
    return null;
  }

  return (
    <>
      <div className="image-preview">
        <label>{existingFileName}</label>
        <div>
          <img
            src={`${process.env.REACT_APP_API_URL}/api/images/${existingBlobName.replace(/\//g, '|')}`}
            alt="Selected"
            height="100px"
          />
        </div>
      </div>
    </>
  );
};

export default ImagePreview;
